// @flow
export const filterId: 'productionType' = 'productionType';
